import z from 'zod';

export const FEEDBACK_OPTIONS = [
  { label: 'Dúvida', value: 'duvida' },
  { label: 'Sugestão', value: 'sugestao' },
  { label: 'Erro na plataforma', value: 'erro na plataforma' },
  { label: 'Outros', value: 'outros' },
];

export const CreateFeedbackFormSchema = z.object({
  message: z.string().min(1, 'O campo mensagem é obrigatório').trim(),
  feedbackType: z.string().min(1, 'O campo mensagem é obrigatório').trim(),
});

export type CreateFeedbackFormState = {
  values: {
    message: string;
    feedbackType: string;
  };
  errors?: {
    message?: string[];
    feedbackType?: string[];
  };
  success?: boolean;
  message?: string;
  error?: string;
};
